export const ROUTES = {
  home: "/",
  login: "/login",
  restore: "/restore",
  unsubscribe: "/unsubscribe",
  unsubscribeSuccess: "/unsubscribe/success",
  contact: "/contact",
  eLibrary: "/eLibrary",
  downloads: "/downloads",
  schedule: "/schedule",
  tests: "/quizzes",
  testsQuiz: "/quizzes/:id",
  appointments: "/appointments",
}